import { createApi } from '@reduxjs/toolkit/query/react';

import { config } from '../config';
import { defaultHeadersPayments } from './defaultHeaders';
import { createCustomBaseQuery } from './utils/customBaseQuery';

export interface GenerateTokenResponse {
  accessToken: string;
  tokenType: string;
  expiresIn: number;
  refreshToken: string;
  clientId: string;
  tenantName: string;
  issued: string;
  expires: string;
}

interface CreateSessionRequest {
  accessToken: string;
  amount: string;
  agentId?: string;
  currency?: string;
  firstName?: string;
  lastName?: string;
  primaryEmailAddress?: string;
  mobilePhoneNumber?: string;
  country: string;
  runCaptureService: string;
  location: {
    addressLine1?: string;
    city?: string;
    stateCode?: string;
    postalCode?: string;
  };
  merchantReferenceCode?: string;
}

interface CreateSessionResponse {
  sessionId: string;
  linkId: string;
}

// Use the reusable custom base query
const customBaseQuery = createCustomBaseQuery({
  baseUrl: config.msCommercialInsApi,
  defaultHeaders: defaultHeadersPayments,
  reducerPath: 'pciPalApi',
});

export const pciPalApi = createApi({
  reducerPath: 'pciPalApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getToken: builder.mutation<GenerateTokenResponse, void>({
      query: () => '/pcipal/payments/token',
    }),
    createSession: builder.mutation<CreateSessionResponse, CreateSessionRequest>({
      query: ({ accessToken, ...rest }) => ({
        url: '/pcipal/payments/create-session',
        method: 'POST',
        headers: {
          'X-AccessToken': accessToken,
        },
        body: rest,
      }),
    }),
  }),
});
